import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FiArrowLeft,
  FiBriefcase,
  FiCheck,
  FiChevronRight,
  FiGlobe,
  FiMail,
  FiMapPin,
  FiMessageCircle,
  FiPlus,
  FiTrash2,
  FiUser,
} from 'react-icons/fi';
import { submitCreatorRegistration } from '../services/api';

const CATEGORY_OPTIONS = [
  'BFSI & Finance',
  'Stock Market & Trading',
  'Crypto & Web3',
  'Mutual Funds & Investments',
  'Education & EdTech',
  'Technology & Gadgets',
  'Gaming & Esports',
  'Entertainment',
  'Comedy & Memes',
  'Lifestyle',
  'Fashion',
  'Beauty & Skincare',
  'Health & Fitness',
  'Travel',
  'Food',
  'Business & Entrepreneurship',
  'Affiliate Marketing',
  'News & Media',
  'Automobile',
  'Real Estate',
  'Parenting & Family',
  'Agriculture',
  'Motivation & Self Improvement',
  'Regional Content',
  'Other',
];

const SOCIAL_OPTIONS = ['YouTube', 'Instagram', 'Facebook', 'Telegram', 'Other'];
const FORM_STEPS = ['Basic Details', 'Social Profiles', 'Collaboration Details', 'Review & Submit'];
const LANGUAGES = ['Hindi', 'English', 'Marathi', 'Tamil', 'Telugu', 'Kannada', 'Bengali', 'Gujarati', 'Punjabi', 'Malayalam', 'Urdu', 'Other'];
const COUNTRIES = ['India', 'United States', 'United Kingdom', 'Canada', 'Australia', 'United Arab Emirates', 'Saudi Arabia', 'Singapore', 'Qatar', 'Germany', 'Other'];
const INDIAN_STATES = ['Andaman and Nicobar Islands', 'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chandigarh', 'Chhattisgarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Ladakh', 'Lakshadweep', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Puducherry', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'];
const CITY_BY_STATE = {
  'Andaman and Nicobar Islands': ['Port Blair', 'Havelock Island', 'Neil Island', 'Other'],
  'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Tirupati', 'Other'],
  'Arunachal Pradesh': ['Itanagar', 'Naharlagun', 'Tawang', 'Other'],
  'Assam': ['Guwahati', 'Dibrugarh', 'Silchar', 'Jorhat', 'Other'],
  'Bihar': ['Patna', 'Gaya', 'Muzaffarpur', 'Bhagalpur', 'Other'],
  'Chandigarh': ['Chandigarh', 'Other'],
  'Chhattisgarh': ['Raipur', 'Bilaspur', 'Durg', 'Bhilai', 'Other'],
  'Dadra and Nagar Haveli and Daman and Diu': ['Silvassa', 'Daman', 'Diu', 'Other'],
  'Delhi': ['New Delhi', 'Dwarka', 'Rohini', 'Saket', 'Other'],
  'Goa': ['Panaji', 'Margao', 'Mapusa', 'Other'],
  'Gujarat': ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Other'],
  'Haryana': ['Gurugram', 'Faridabad', 'Panipat', 'Hisar', 'Other'],
  'Himachal Pradesh': ['Shimla', 'Manali', 'Dharamshala', 'Other'],
  'Jammu and Kashmir': ['Srinagar', 'Jammu', 'Anantnag', 'Other'],
  'Jharkhand': ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Other'],
  'Karnataka': ['Bengaluru', 'Mysuru', 'Hubballi', 'Mangaluru', 'Other'],
  'Kerala': ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Thrissur', 'Other'],
  'Ladakh': ['Leh', 'Kargil', 'Other'],
  'Lakshadweep': ['Kavaratti', 'Agatti', 'Other'],
  'Madhya Pradesh': ['Bhopal', 'Indore', 'Jabalpur', 'Gwalior', 'Other'],
  'Maharashtra': ['Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Other'],
  'Manipur': ['Imphal', 'Thoubal', 'Other'],
  'Meghalaya': ['Shillong', 'Tura', 'Other'],
  'Mizoram': ['Aizawl', 'Lunglei', 'Other'],
  'Nagaland': ['Kohima', 'Dimapur', 'Other'],
  'Odisha': ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Other'],
  'Puducherry': ['Puducherry', 'Karaikal', 'Other'],
  'Punjab': ['Ludhiana', 'Amritsar', 'Jalandhar', 'Mohali', 'Other'],
  'Rajasthan': ['Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Other'],
  'Sikkim': ['Gangtok', 'Namchi', 'Other'],
  'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Other'],
  'Telangana': ['Hyderabad', 'Warangal', 'Secunderabad', 'Other'],
  'Tripura': ['Agartala', 'Udaipur', 'Other'],
  'Uttar Pradesh': ['Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Other'],
  'Uttarakhand': ['Dehradun', 'Haridwar', 'Haldwani', 'Other'],
  'West Bengal': ['Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Other'],
};
const OTHER_STATE_OPTIONS = ['Other'];
const STEPS = ['basic', 'social', 'details', 'review'];
const INPUT_CLASS = 'w-full rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm text-slate-900 shadow-sm outline-none transition placeholder:text-slate-400 hover:border-slate-300 focus:border-sky-500 focus:ring-4 focus:ring-sky-500/10';
const LABEL_CLASS = 'mb-1.5 flex items-center gap-2 text-sm font-semibold text-slate-700';

const FieldLabel = ({ children, icon: Icon, required = false }) => (
  <label className={LABEL_CLASS}>
    {Icon && <Icon aria-hidden="true" className="h-4 w-4 text-sky-600" />}
    <span>
      {children}
      {required && <span className="ml-1 text-rose-500" aria-label="required">*</span>}
    </span>
  </label>
);

const ChoiceButton = ({ selected, children, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={selected}
    className={`flex min-h-11 items-center justify-between gap-2 rounded-xl border px-3 py-2.5 text-left text-sm font-medium transition focus:outline-none focus:ring-4 focus:ring-sky-500/10 ${
      selected
        ? 'border-sky-600 bg-sky-50 text-sky-800 shadow-sm ring-1 ring-sky-600/15'
        : 'border-slate-200 bg-white text-slate-700 hover:border-sky-300 hover:bg-slate-50'
    }`}
  >
    <span>{children}</span>
    {selected && <FiCheck aria-hidden="true" className="h-4 w-4 shrink-0 text-sky-700" />}
  </button>
);

const defaultSocialProfile = () => ({
  id: `profile-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
  platform: 'YouTube',
  profileName: '',
  profileUrl: '',
  followerCount: '',
  averageViews: '',
  primaryCategory: '',
  secondaryCategories: [],
});

const defaultFormState = {
  fullName: '',
  brandName: '',
  profileType: 'Individual Creator',
  country: 'India',
  state: '',
  city: '',
  preferredLanguages: ['Hindi'],
  businessEmail: '',
  whatsappNumber: '',
  preferredContactMethod: 'WhatsApp',
  socialProfiles: [defaultSocialProfile()],
  categories: [],
  otherCategory: '',
  primaryAudienceLocation: 'India',
  audienceLanguages: ['Hindi'],
  followerRange: '',
  collaborationTypes: [],
  expectedPayout: '',
  minimumCampaignBudget: '',
  interestedCampaignVerticals: [],
  availability: 'Available Now',
  additionalInformation: '',
  consentAccurate: false,
  consentContact: false,
  consentPrivacy: false,
};

const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
const validatePhone = (value) => /^\+?[1-9]\d{7,14}$/.test(String(value || '').replace(/\s+/g, ''));
const validateUrl = (value) => {
  try {
    const url = new URL(String(value || '').trim());
    return ['http:', 'https:'].includes(url.protocol);
  } catch (error) {
    return false;
  }
};

const stepValidation = (step, formData) => {
  const errors = {};

  if (step === 'basic') {
    if (!formData.fullName) errors.fullName = 'Full name is required.';
    if (!formData.brandName) errors.brandName = 'Brand or creator name is required.';
    if (!formData.profileType) errors.profileType = 'Profile type is required.';
    if (!formData.state) errors.state = 'State is required.';
    if (!formData.city) errors.city = 'City is required.';
    if (!formData.businessEmail || !validateEmail(formData.businessEmail)) errors.businessEmail = 'Enter a valid email address.';
    if (!formData.whatsappNumber || !validatePhone(formData.whatsappNumber)) errors.whatsappNumber = 'Enter a valid WhatsApp number with country code.';
    if (!formData.preferredLanguages || formData.preferredLanguages.length === 0) errors.preferredLanguages = 'Select at least one preferred language.';
  }

  if (step === 'social') {
    if (!Array.isArray(formData.socialProfiles) || formData.socialProfiles.length === 0) {
      errors.socialProfiles = 'Add at least one social profile.';
    } else {
      formData.socialProfiles.forEach((profile, index) => {
        if (!profile.platform) errors[`social-${index}-platform`] = 'Platform is required.';
        if (!profile.profileName) errors[`social-${index}-profileName`] = 'Profile name is required.';
        if (!profile.profileUrl || !validateUrl(profile.profileUrl)) errors[`social-${index}-profileUrl`] = 'Enter a valid profile URL.';
        if (!profile.primaryCategory) errors[`social-${index}-primaryCategory`] = 'Primary content category is required.';
      });
    }
  }

  if (step === 'details') {
    if (!formData.categories || formData.categories.length === 0) errors.categories = 'Choose at least one category.';
    if (formData.categories.includes('Other') && !formData.otherCategory.trim()) errors.otherCategory = 'Please specify the other category.';
    if (!formData.primaryAudienceLocation) errors.primaryAudienceLocation = 'Select primary audience location.';
    if (!formData.audienceLanguages || formData.audienceLanguages.length === 0) errors.audienceLanguages = 'Select at least one audience language.';
    if (!formData.followerRange) errors.followerRange = 'Follower range is required.';
    if (!formData.collaborationTypes || formData.collaborationTypes.length === 0) errors.collaborationTypes = 'Choose at least one collaboration type.';
    if (!formData.availability) errors.availability = 'Availability is required.';
  }

  if (step === 'review') {
    if (!formData.consentAccurate) errors.consentAccurate = 'Please confirm the information is accurate.';
    if (!formData.consentContact) errors.consentContact = 'Please authorize RT JobSpot to contact you.';
    if (!formData.consentPrivacy) errors.consentPrivacy = 'Please agree to the privacy policy.';
  }

  return errors;
};

const CreatorRegistrationPage = () => {
  const [formData, setFormData] = useState(defaultFormState);
  const [currentStep, setCurrentStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittedMessage, setSubmittedMessage] = useState('');
  const [registrationId, setRegistrationId] = useState('');
  const [searchText, setSearchText] = useState('');

  const availableStates = formData.country === 'India' ? INDIAN_STATES : OTHER_STATE_OPTIONS;
  const availableCities = formData.country === 'India' && formData.state ? (CITY_BY_STATE[formData.state] || ['Other']) : ['Other'];

  const currentStepKey = STEPS[currentStep];
  const currentStepDetails = {
    basic: {
      title: 'Your basic details',
      description: 'Tell us how to reach you and where you are based.',
      icon: FiUser,
    },
    social: {
      title: 'Your social profiles',
      description: 'Add the platforms and profiles you want brands to discover.',
      icon: FiGlobe,
    },
    details: {
      title: 'Your collaboration preferences',
      description: 'Help us understand your audience and the campaigns you are interested in.',
      icon: FiBriefcase,
    },
    review: {
      title: 'Review your registration',
      description: 'Check your details and provide consent before submitting.',
      icon: FiCheck,
    },
  }[currentStepKey];

  const filteredCategories = useMemo(() => {
    const query = searchText.trim().toLowerCase();
    if (!query) return CATEGORY_OPTIONS;
    return CATEGORY_OPTIONS.filter((category) => category.toLowerCase().includes(query));
  }, [searchText]);

  const updateField = (field, value) => {
    setFormData((previous) => {
      const next = { ...previous, [field]: value };

      if (field === 'country' && value !== 'India') {
        next.state = 'Other';
        next.city = 'Other';
      }

      if (field === 'country' && value === 'India' && !INDIAN_STATES.includes(previous.state)) {
        next.state = 'Andhra Pradesh';
        next.city = 'Visakhapatnam';
      }

      if (field === 'state' && value && value !== 'Other') {
        next.city = CITY_BY_STATE[value]?.[0] || '';
      }

      if (field === 'state' && value === 'Other') {
        next.city = 'Other';
      }

      return next;
    });
    setErrors((previous) => ({ ...previous, [field]: '' }));
  };

  const updateSocialProfile = (id, field, value) => {
    setFormData((previous) => ({
      ...previous,
      socialProfiles: previous.socialProfiles.map((profile) =>
        profile.id === id ? { ...profile, [field]: value } : profile
      ),
    }));
  };

  const addSocialProfile = () => {
    setFormData((previous) => ({
      ...previous,
      socialProfiles: [...previous.socialProfiles, defaultSocialProfile()],
    }));
  };

  const removeSocialProfile = (id) => {
    setFormData((previous) => ({
      ...previous,
      socialProfiles: previous.socialProfiles.filter((profile) => profile.id !== id),
    }));
  };

  const toggleArrayValue = (field, value) => {
    setFormData((previous) => {
      const selected = new Set(previous[field]);
      if (selected.has(value)) {
        selected.delete(value);
      } else {
        selected.add(value);
      }
      return { ...previous, [field]: Array.from(selected) };
    });
  };

  const handleNext = () => {
    const nextErrors = stepValidation(currentStepKey, formData);
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) {
      return;
    }
    setCurrentStep((previous) => Math.min(previous + 1, FORM_STEPS.length - 1));
  };

  const handleBack = () => {
    setCurrentStep((previous) => Math.max(previous - 1, 0));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const reviewErrors = stepValidation('review', formData);
    setErrors(reviewErrors);
    if (Object.keys(reviewErrors).length > 0) {
      setCurrentStep(FORM_STEPS.length - 1);
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        ...formData,
        totalFollowers: Math.max(
          ...formData.socialProfiles.map((profile) => Number(String(profile.followerCount || '').replace(/[^\d]/g, '')) || 0),
          0,
        ),
      };
      const result = await submitCreatorRegistration(payload);
      setSubmittedMessage('Registration submitted successfully. Our team will review your profile and contact you for relevant collaborations.');
      setRegistrationId(result.registrationId);
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      setErrors(error.errors || { form: error.message || 'Unable to submit your registration right now.' });
      if (error.message && error.message.toLowerCase().includes('duplicate')) {
        setSubmittedMessage('');
      }
    }
  };

  const renderFieldError = (field) => (errors[field] ? <span className="mt-2 block text-sm text-red-600">{errors[field]}</span> : null);

  const renderStepContent = () => {
    if (submittedMessage) {
      return (
        <div className="rounded-3xl border border-emerald-200 bg-emerald-50 p-8 text-center shadow-sm">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-500 text-2xl text-white">✓</div>
          <h3 className="text-2xl font-bold text-slate-900">Registration received</h3>
          <p className="mt-3 text-slate-700">{submittedMessage}</p>
          <div className="mt-5 inline-flex rounded-full border border-emerald-300 bg-white px-4 py-2 text-sm font-semibold text-emerald-700">
            Registration ID: {registrationId || 'RTJ-NEW'}
          </div>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <Link to="/" className="rounded-full bg-slate-900 px-5 py-3 font-semibold text-white">Back to home</Link>
          </div>
        </div>
      );
    }

    if (currentStepKey === 'basic') {
      return (
        <div className="space-y-6">
          <div className="grid gap-x-5 gap-y-4 sm:grid-cols-2">
            <div>
              <FieldLabel icon={FiUser} required>Full Name</FieldLabel>
              <input value={formData.fullName} onChange={(event) => updateField('fullName', event.target.value)} className={INPUT_CLASS} placeholder="Enter your full name" autoComplete="name" />
              {renderFieldError('fullName')}
            </div>
            <div>
              <FieldLabel icon={FiBriefcase} required>Creator / Brand / Agency Name</FieldLabel>
              <input value={formData.brandName} onChange={(event) => updateField('brandName', event.target.value)} className={INPUT_CLASS} placeholder="Your brand or agency name" autoComplete="organization" />
              {renderFieldError('brandName')}
            </div>
            <div>
              <FieldLabel required>Profile Type</FieldLabel>
              <select value={formData.profileType} onChange={(event) => updateField('profileType', event.target.value)} className={INPUT_CLASS}>
                {['Individual Creator', 'Influencer Manager', 'Agency', 'Talent Manager', 'Publisher', 'Other'].map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
              {renderFieldError('profileType')}
            </div>
            <div>
              <FieldLabel icon={FiGlobe} required>Country</FieldLabel>
              <select value={formData.country} onChange={(event) => updateField('country', event.target.value)} className={INPUT_CLASS}>
                {COUNTRIES.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>
            <div>
              <FieldLabel icon={FiMapPin} required>State</FieldLabel>
              <select value={formData.state} onChange={(event) => updateField('state', event.target.value)} className={INPUT_CLASS}>
                <option value="">Select state</option>
                {availableStates.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
              {renderFieldError('state')}
            </div>
            <div>
              <FieldLabel icon={FiMapPin} required>City</FieldLabel>
              <select value={formData.city} onChange={(event) => updateField('city', event.target.value)} className={INPUT_CLASS} disabled={!formData.state}>
                <option value="">Select city</option>
                {availableCities.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
              {renderFieldError('city')}
            </div>
            <div className="md:col-span-2">
              <FieldLabel required>Preferred Language(s)</FieldLabel>
              <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
                {LANGUAGES.map((language) => (
                  <ChoiceButton key={language} selected={formData.preferredLanguages.includes(language)} onClick={() => toggleArrayValue('preferredLanguages', language)}>{language}</ChoiceButton>
                ))}
              </div>
              {renderFieldError('preferredLanguages')}
            </div>
            <div>
              <FieldLabel icon={FiMail} required>Business Email</FieldLabel>
              <input type="email" value={formData.businessEmail} onChange={(event) => updateField('businessEmail', event.target.value)} className={INPUT_CLASS} placeholder="name@company.com" autoComplete="email" />
              {renderFieldError('businessEmail')}
            </div>
            <div>
              <FieldLabel icon={FiMessageCircle} required>WhatsApp Number</FieldLabel>
              <input type="tel" value={formData.whatsappNumber} onChange={(event) => updateField('whatsappNumber', event.target.value)} className={INPUT_CLASS} placeholder="+91 98765 43210" autoComplete="tel" />
              {renderFieldError('whatsappNumber')}
            </div>
            <div className="md:col-span-2">
              <FieldLabel>Preferred Contact Method</FieldLabel>
              <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
                {['WhatsApp', 'Email', 'Phone'].map((method) => (
                  <ChoiceButton key={method} selected={formData.preferredContactMethod === method} onClick={() => updateField('preferredContactMethod', method)}>{method}</ChoiceButton>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (currentStepKey === 'social') {
      return (
        <div className="space-y-4">
          {formData.socialProfiles.map((profile, index) => (
            <div key={profile.id} className="rounded-2xl border border-slate-200 bg-slate-50/70 p-4 sm:p-5">
              <div className="mb-4 flex items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-sky-100 text-sm font-bold text-sky-700">{index + 1}</span>
                  <h4 className="font-bold text-slate-900">Social Profile</h4>
                </div>
                {formData.socialProfiles.length > 1 && (
                  <button type="button" onClick={() => removeSocialProfile(profile.id)} className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-semibold text-rose-600 transition hover:bg-rose-50" aria-label={`Remove social profile ${index + 1}`}>
                    <FiTrash2 aria-hidden="true" className="h-4 w-4" />
                    Remove
                  </button>
                )}
              </div>

              <div className="grid gap-x-4 gap-y-3.5 sm:grid-cols-2">
                <div>
                  <FieldLabel required>Platform</FieldLabel>
                  <select value={profile.platform} onChange={(event) => updateSocialProfile(profile.id, 'platform', event.target.value)} className={INPUT_CLASS}>
                    {SOCIAL_OPTIONS.map((option) => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                  {renderFieldError(`social-${index}-platform`)}
                </div>
                <div>
                  <FieldLabel required>Profile or Channel Name</FieldLabel>
                  <input value={profile.profileName} onChange={(event) => updateSocialProfile(profile.id, 'profileName', event.target.value)} className={INPUT_CLASS} placeholder="Channel or username" />
                  {renderFieldError(`social-${index}-profileName`)}
                </div>
                <div className="md:col-span-2">
                  <FieldLabel required>Full Profile URL</FieldLabel>
                  <input type="url" value={profile.profileUrl} onChange={(event) => updateSocialProfile(profile.id, 'profileUrl', event.target.value)} className={INPUT_CLASS} placeholder="https://..." />
                  {renderFieldError(`social-${index}-profileUrl`)}
                </div>
                <div>
                  <FieldLabel>Follower / Subscriber Count</FieldLabel>
                  <input inputMode="numeric" value={profile.followerCount} onChange={(event) => updateSocialProfile(profile.id, 'followerCount', event.target.value)} className={INPUT_CLASS} placeholder="e.g. 120000" />
                </div>
                <div>
                  <FieldLabel>Average Views per Post or Video</FieldLabel>
                  <input inputMode="numeric" value={profile.averageViews} onChange={(event) => updateSocialProfile(profile.id, 'averageViews', event.target.value)} className={INPUT_CLASS} placeholder="Optional" />
                </div>
                <div>
                  <FieldLabel required>Primary Content Category</FieldLabel>
                  <select value={profile.primaryCategory} onChange={(event) => updateSocialProfile(profile.id, 'primaryCategory', event.target.value)} className={INPUT_CLASS}>
                    <option value="">Select category</option>
                    {CATEGORY_OPTIONS.map((option) => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                  {renderFieldError(`social-${index}-primaryCategory`)}
                </div>
                <div>
                  <FieldLabel>Secondary Categories</FieldLabel>
                  <input value={profile.secondaryCategories.join(', ')} onChange={(event) => updateSocialProfile(profile.id, 'secondaryCategories', event.target.value.split(',').map((item) => item.trim()).filter(Boolean))} className={INPUT_CLASS} placeholder="Optional" />
                </div>
              </div>
            </div>
          ))}

          <button type="button" onClick={addSocialProfile} className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-xl border border-dashed border-sky-300 bg-sky-50/60 px-4 py-2.5 text-sm font-semibold text-sky-800 transition hover:border-sky-500 hover:bg-sky-50 sm:w-auto">
            <FiPlus aria-hidden="true" className="h-4 w-4" />
            Add another social profile
          </button>
          {renderFieldError('socialProfiles')}
        </div>
      );
    }

    if (currentStepKey === 'details') {
      return (
        <div className="space-y-5">
          <div>
            <FieldLabel required>Creator Categories</FieldLabel>
            <input value={searchText} onChange={(event) => setSearchText(event.target.value)} placeholder="Search categories" className={`${INPUT_CLASS} mb-3`} />
            <div className="grid max-h-64 grid-cols-1 gap-2 overflow-auto rounded-2xl border border-slate-200 bg-slate-50/70 p-3 sm:grid-cols-2 lg:grid-cols-3">
              {filteredCategories.map((category) => (
                <ChoiceButton key={category} selected={formData.categories.includes(category)} onClick={() => toggleArrayValue('categories', category)}>{category}</ChoiceButton>
              ))}
            </div>
            {renderFieldError('categories')}
            {formData.categories.includes('Other') && (
              <div className="mt-3">
                <label className="mb-2 block text-sm font-semibold text-slate-700">Other Category Details</label>
                <input value={formData.otherCategory} onChange={(event) => updateField('otherCategory', event.target.value)} className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/10" placeholder="Please specify your category" />
                {renderFieldError('otherCategory')}
              </div>
            )}
          </div>

          <div className="grid gap-5 md:grid-cols-2">
            <div>
              <FieldLabel required>Primary Audience Location</FieldLabel>
              <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
                {['India', 'International', 'Both'].map((option) => (
                  <ChoiceButton key={option} selected={formData.primaryAudienceLocation === option} onClick={() => updateField('primaryAudienceLocation', option)}>{option}</ChoiceButton>
                ))}
              </div>
              {renderFieldError('primaryAudienceLocation')}
            </div>
            <div>
              <FieldLabel required>Audience Language(s)</FieldLabel>
              <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
                {LANGUAGES.map((language) => (
                  <ChoiceButton key={language} selected={formData.audienceLanguages.includes(language)} onClick={() => toggleArrayValue('audienceLanguages', language)}>{language}</ChoiceButton>
                ))}
              </div>
              {renderFieldError('audienceLanguages')}
            </div>
            <div>
              <FieldLabel required>Follower Range</FieldLabel>
              <select value={formData.followerRange} onChange={(event) => updateField('followerRange', event.target.value)} className={INPUT_CLASS}>
                <option value="">Select range</option>
                {['5K–10K', '10K–25K', '25K–50K', '50K–100K', '100K–500K', '500K+'].map((range) => (
                  <option key={range} value={range}>{range}</option>
                ))}
              </select>
              {renderFieldError('followerRange')}
            </div>
            <div>
              <FieldLabel required>Availability</FieldLabel>
              <select value={formData.availability} onChange={(event) => updateField('availability', event.target.value)} className={INPUT_CLASS}>
                {['Available Now', 'Available Later', 'Not Currently Available'].map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
              {renderFieldError('availability')}
            </div>
            <div className="md:col-span-2">
              <FieldLabel required>Collaboration Types</FieldLabel>
              <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
                {['Sponsored Post', 'Reel', 'YouTube Integration', 'Dedicated Video', 'Story Promotion', 'Telegram Promotion', 'Facebook Promotion', 'Affiliate Campaign', 'Performance Campaign', 'Barter', 'Other'].map((option) => (
                  <ChoiceButton key={option} selected={formData.collaborationTypes.includes(option)} onClick={() => toggleArrayValue('collaborationTypes', option)}>{option}</ChoiceButton>
                ))}
              </div>
              {renderFieldError('collaborationTypes')}
            </div>
            <div>
              <FieldLabel>Expected Payout per Collaboration</FieldLabel>
              <input value={formData.expectedPayout} onChange={(event) => updateField('expectedPayout', event.target.value)} className={INPUT_CLASS} placeholder="Optional" />
            </div>
            <div>
              <FieldLabel>Minimum Campaign Budget</FieldLabel>
              <input value={formData.minimumCampaignBudget} onChange={(event) => updateField('minimumCampaignBudget', event.target.value)} className={INPUT_CLASS} placeholder="Optional" />
            </div>
            <div className="md:col-span-2">
              <FieldLabel>Interested Campaign Verticals</FieldLabel>
              <input value={formData.interestedCampaignVerticals.join(', ')} onChange={(event) => updateField('interestedCampaignVerticals', event.target.value.split(',').map((item) => item.trim()).filter(Boolean))} className={INPUT_CLASS} placeholder="e.g. BFSI, EdTech, Beauty" />
            </div>
            <div className="md:col-span-2">
              <FieldLabel>Additional Information</FieldLabel>
              <textarea value={formData.additionalInformation} onChange={(event) => updateField('additionalInformation', event.target.value)} className={`${INPUT_CLASS} min-h-[110px] resize-y`} placeholder="Tell us about your content, audience, or any campaign preferences" />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="space-y-6">
        <div className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
          <h3 className="text-xl font-bold text-slate-900">Review & Consent</h3>
          <div className="mt-4 space-y-4">
            <div className="rounded-2xl bg-slate-50 p-4">
              <p className="text-sm font-semibold uppercase tracking-[0.1em] text-slate-500">Summary</p>
              <dl className="mt-3 grid gap-3 text-sm text-slate-700 md:grid-cols-2">
                <div><dt className="font-semibold text-slate-900">Name</dt><dd>{formData.fullName}</dd></div>
                <div><dt className="font-semibold text-slate-900">Brand</dt><dd>{formData.brandName}</dd></div>
                <div><dt className="font-semibold text-slate-900">Location</dt><dd>{formData.city}, {formData.state}</dd></div>
                <div><dt className="font-semibold text-slate-900">Email</dt><dd>{formData.businessEmail}</dd></div>
              </dl>
            </div>
            <label className="flex gap-3 rounded-2xl border border-slate-200 p-3">
              <input type="checkbox" checked={formData.consentAccurate} onChange={(event) => updateField('consentAccurate', event.target.checked)} className="mt-1 h-5 w-5" />
              <span className="text-sm text-slate-700">The submitted information is accurate.</span>
            </label>
            {renderFieldError('consentAccurate')}

            <label className="flex gap-3 rounded-2xl border border-slate-200 p-3">
              <input type="checkbox" checked={formData.consentContact} onChange={(event) => updateField('consentContact', event.target.checked)} className="mt-1 h-5 w-5" />
              <span className="text-sm text-slate-700">I authorize RT JobSpot to contact me regarding relevant brand collaborations.</span>
            </label>
            {renderFieldError('consentContact')}

            <label className="flex gap-3 rounded-2xl border border-slate-200 p-3">
              <input type="checkbox" checked={formData.consentPrivacy} onChange={(event) => updateField('consentPrivacy', event.target.checked)} className="mt-1 h-5 w-5" />
              <span className="text-sm text-slate-700">I agree to the Privacy Policy and Terms of Service.</span>
            </label>
            {renderFieldError('consentPrivacy')}

            <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4 text-sm text-slate-700">
              Submitted contact details will be used for business communication, campaign matching, and collaboration outreach. We will not share your information outside the collaboration workflow without your consent.
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(59,130,246,0.14),transparent_18%),linear-gradient(180deg,#f8fbff_0%,#eef4ff_100%)]">
      <header className="border-b border-slate-200 bg-white/80 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
          <Link to="/" className="flex items-center gap-3">
            <img src="/rt-jobspot-logo.svg" alt="RT JobSpot" className="h-11 w-11 rounded-full object-cover" />
            <div>
              <div className="text-lg font-black text-slate-900">RT JobSpot</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Creator registration</div>
            </div>
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-8 md:py-12">
        <div className="mb-8 rounded-[30px] bg-gradient-to-r from-slate-950 via-sky-900 to-primary-light p-6 text-white shadow-[0_20px_50px_rgba(15,23,42,0.2)] ring-1 ring-white/10">
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.22em] text-secondary-light">Creator network</p>
          <h1 className="text-3xl font-black md:text-4xl">Join RT JobSpot for brand collaborations</h1>
          <p className="mt-3 max-w-2xl text-slate-200">Register as a creator, influencer, agency, manager, or publisher across India. We welcome all categories, all languages, and creators of all sizes.</p>
        </div>

        <div className="mb-5 overflow-x-auto rounded-[26px] bg-white/80 p-2 shadow-[0_15px_35px_rgba(15,23,42,0.08)] ring-1 ring-slate-200 backdrop-blur-sm sm:mb-8 sm:p-3">
          <div className="flex min-w-max gap-2">
            {FORM_STEPS.map((label, index) => (
              <div key={label} className={`flex items-center gap-2 rounded-full px-3 py-2 text-xs font-semibold transition sm:px-4 sm:text-sm ${index === currentStep ? 'bg-slate-900 text-white shadow-md' : (index < currentStep ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600')}`}>
                <span className={`flex h-6 w-6 items-center justify-center rounded-full text-xs ${index === currentStep ? 'bg-white/20 text-white' : 'bg-slate-200 text-slate-600'}`}>{index < currentStep ? <FiCheck aria-hidden="true" /> : index + 1}</span>
                {label}
              </div>
            ))}
          </div>
        </div>

        <form onSubmit={handleSubmit} className="rounded-[24px] bg-white p-4 shadow-[0_25px_60px_rgba(15,23,42,0.08)] ring-1 ring-slate-200 sm:rounded-[30px] sm:p-6 md:p-8">
          {!submittedMessage && (
            <div className="mb-6 flex items-start gap-3 border-b border-slate-100 pb-5 sm:mb-7">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-sky-50 text-sky-700 ring-1 ring-sky-100">
                <currentStepDetails.icon aria-hidden="true" className="h-5 w-5" />
              </span>
              <div>
                <h2 className="text-lg font-bold text-slate-900 sm:text-xl">{currentStepDetails.title}</h2>
                <p className="mt-1 text-sm leading-5 text-slate-500">{currentStepDetails.description}</p>
              </div>
            </div>
          )}
          {renderStepContent()}

          {!submittedMessage && (
            <div className="mt-6 flex flex-col-reverse gap-3 border-t border-slate-100 pt-4 sm:mt-8 sm:flex-row sm:justify-between sm:pt-5">
              <button type="button" onClick={handleBack} disabled={currentStep === 0} className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50">
                <FiArrowLeft aria-hidden="true" className="h-4 w-4" />
                Back
              </button>

              {currentStep < FORM_STEPS.length - 1 ? (
                <button type="button" onClick={handleNext} className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-sky-600 to-primary px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-sky-200 transition hover:brightness-110">
                  Continue
                  <FiChevronRight aria-hidden="true" className="h-4 w-4" />
                </button>
              ) : (
                <button type="submit" disabled={isSubmitting} className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-amber-300 to-yellow-400 px-5 py-3 text-sm font-semibold text-slate-900 shadow-lg shadow-yellow-200 transition hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-60">
                  {isSubmitting ? 'Submitting...' : 'Submit Registration'}
                  {!isSubmitting && <FiCheck aria-hidden="true" className="h-4 w-4" />}
                </button>
              )}
            </div>
          )}
        </form>
      </main>
    </div>
  );
};

export default CreatorRegistrationPage;
